<template>
  <div class="step_inner">
    <h2>1.职位信息</h2>
    <el-form ref="form" :model="formData"  :rules="rules" label-width="120px">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="项目名称" prop="project_id">

            <el-select
              v-model="projectInfo" placeholder="请选择项目"
                clearable
                filterable
                style="width:100%"
                value-key="project_id"
                @change="selectProject"
              >
              <el-option
                v-for="item in projectDataList"
                :key="item.project_id"
                :label="item.name"
                :value="item"
              />
            </el-select>
          </el-form-item>

          <!--<el-form-item label="项目描述">
            {{projectInfo.description||''}}
          </el-form-item>-->

          <el-form-item label="公司LOGO">
            <el-image :src="projectInfo.company.log_img||''" :style="`width:150px;height:150px;`" fit="fill"/>
          </el-form-item>

          <el-form-item label="公司名称">
            {{projectInfo.company.company_name||''}}
          </el-form-item>

          <el-form-item label="招聘标题" prop="title">
            <el-input placeholder="请输入标题" v-model="formData.title"></el-input>
          </el-form-item>


          <el-form-item label="招聘头像" prop="logo">
            <imageUpload v-model="formData.logo"/>
          </el-form-item>

          <el-form-item label="工作性质">
            兼职
          </el-form-item>

          <el-form-item label="兼职描述" prop="type_remarks">
            <el-input placeholder="请输入简短描述" v-model="formData.type_remarks"></el-input>
          </el-form-item>

          <el-form-item label="职位类别" prop="class_id" >
            <el-input placeholder="职位类别" @focus="showCategory" v-model="formData.class_name"></el-input>
          </el-form-item>
          
          <el-form-item label="任职要求" prop="job_require">
            <el-input type="textarea" v-model="formData.job_require" placeholder="请输入任职要求"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="活动开始日期" prop="job_start_at">
            <el-date-picker v-model="formData.job_start_at"  type="datetime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item>

          <el-form-item label="活动结束日期" prop="job_end_at">
            <el-date-picker v-model="formData.job_end_at" type="datetime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item>


          <el-form-item label="报名截止日期" prop="registration_end_at">
              <el-date-picker
                v-model="formData.registration_end_at"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetime"
                format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择时间">
              </el-date-picker>
          </el-form-item>


          <el-form-item label="性别要求" prop="sex">
            <el-radio-group v-model="formData.sex">
              <el-radio :label="0">男女不限</el-radio>
              <el-radio :label="1">男</el-radio>
              <el-radio :label="2">女</el-radio>
            </el-radio-group>
          </el-form-item>


         <!-- <el-form-item label="招聘人数" prop="number">
            <el-input placeholder="请输入招聘人数" v-model="formData.number"></el-input>
          </el-form-item>-->


          <el-form-item label="学历要求" prop="education">
            <el-select
              v-model="formData.education" placeholder="请选择"
                clearable
                filterable
                style="width:100%"
              >
                <el-option label="不限" value="0"></el-option>
                <el-option label="初中及以下" value="1"></el-option>
                <el-option label="高中" value="2"></el-option>
                <el-option label="大专" value="3"></el-option>
                <el-option label="本科" value="4"></el-option>
                <el-option label="研究生" value="5"></el-option>
            </el-select>
          </el-form-item>



          <el-form-item label="专业要求" prop="major">
            <el-input v-model="formData.major" placeholder="请输入"></el-input>
          </el-form-item>

          <el-form-item label="年龄要求" prop="age_min">
          <row>
            <el-col :span="11">
              <el-input-number v-model="formData.age_min" placeholder="最小年龄" ></el-input-number>
            </el-col>
            <el-col class="line" :span="2" style="text-align:center">-</el-col>
            <el-col :span="11">
              <el-input-number v-model="formData.age_max" placeholder="最大年龄"></el-input-number>
            </el-col>
          </row>
          </el-form-item>


          <el-form-item label="工作环境" prop="photo">
            <el-upload
              class="upload"
              :action="uploadFileUrl"
              :on-remove="(files) => handleRemove(files)"
              :on-success="(response, files) => uploadFileSuccess(response, files)"
              :on-error="uploadFileError"
              :file-list="formData.photoFiles"
              list-type="picture-card"
              >
                <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>


          <el-form-item label="职位描述" prop="description">
            <el-input type="textarea" v-model="formData.description" placeholder="请输入职位描述"></el-input>
          </el-form-item>

        </el-col>

      </el-row>


        <el-form-item label="地址信息" prop="address">
          <el-button type="primary" plain @click="selectAddress">添加地址</el-button>
        </el-form-item>
          <el-table :data="formData.address" style="width: 100%"  >
            <el-table-column   prop="shop_name" label="店铺"></el-table-column>
            <el-table-column   prop="address" label="地址" ></el-table-column>
            <el-table-column   prop="all_num" label="招聘人数">
                <template slot-scope="scope">
                  <el-form-item :prop="'address.' + scope.$index +'.all_num'" :rules="rules.all_num"  label-width="0px"	>
                      <el-input-number v-model="scope.row.all_num"  :min="0" placeholder="请输入招聘人数"  style="margin-left: 0;"> </el-input-number>
                  </el-form-item>
              </template>
            </el-table-column>
            <el-table-column   prop="sex" label="性别">
            
                <template slot-scope="scope">

                  <el-form-item :prop="'address.' + scope.$index +'.sex'"   label-width="0px"	>
                      <el-select v-model="scope.row.sex" placeholder="请选择">
                        <el-option label="不限" :value="0"></el-option>
                        <el-option label="男" :value="1"></el-option>
                        <el-option label="女" :value="2"></el-option>
                      </el-select>
                  </el-form-item>
              </template>
            </el-table-column>
          
            <el-table-column   prop="remark" label="说明">

                <template slot-scope="scope">
                  <el-form-item :prop="'address.' + scope.$index +'.remark'"   label-width="0px"	>
                    <el-input  v-model="scope.row.remark" placeholder="请输入说明"></el-input>
                  </el-form-item>
              </template>

            </el-table-column>
            <el-table-column  label="操作">
              <template slot-scope="scope">
                <el-button
                  @click.native.prevent="deleteRow(scope.$index, formData.address)"  type="text"  size="small">
                  移除
                </el-button>
              </template>
            </el-table-column>
          </el-table>

      <div style="text-align:center;margin: 20px;">
        <el-button type="primary" @click="handleNextStep">下一步</el-button>
      </div>

    </el-form>
    <category ref="refCategory"  @setClassId="setClassId"></category>
    <address-select-dialog ref="selectAddressDialog" @setAddress="setAddress"></address-select-dialog>
    
  </div>
</template>

<script>
import { projectList} from "@/api/director/project/index";

import ImageUpload from '@/components/ImageUpload';
import Category from './category.vue';
import urlConfig from '@/api/config'
import addressSelectDialog from "@/components/address/address-select-dialog.vue";


export default {
  components: {
    ImageUpload,Category,addressSelectDialog
  },

  props: {
    // 值
    // 文件类型, 例如['png', 'jpg', 'jpeg']
    info: {
      type: Object,
      default: () => {},
    },
   
  },

  data () {
    return {
      projectDataList:[],
      uploadFileUrl:  urlConfig.prod.baseURL +"/web/file/Upload", // 上传的图片服务器地址

      projectInfo: {
            project_id: "",
            name: "",
            description: "",
            company:{
              company_app_id: "",
              company_name: "",
              log_img: ""
            }
          
        },
      formData:  {
        
          project_id:'',//项目id
          company_app_id:'',//企业id
          company_name: '',
          log_img: '',

          title:'',//招聘标题
          logo:'',//招聘头像
          type_id:1,//招聘类型1兼职2全职
          type_remarks:'',//招聘描述
          class_name:'',
          class_id:'',//职位分类id
          address:[],//地址信息
          job_start_at:'',//活动开始时间-时间戳
          job_end_at:'',//活动结束时间-时间戳
          registration_end_at:'',//报名截止时间
          sex:0,//性别1男2女
          education:'0',//学历 0 不限 1 初中及以下 2 高中 3 大专 4 本科 5 研究生
          major:'',//专业要求
          age_min:'',//最小年龄
          age_max:'',//最大年龄
          photoFiles:[],//工作环境
          photo:[],
          description:'',//职位描述
          job_require:"",

          unit:'',//工资单位1 天 2 小时 3 月 4 次 5 单
          wages_min:'',//最低薪资
          wages_max:'',//最高薪资
          wages_way:[],//工资计算方式
          method:'',//1:日结，2:月结，3:周结，:4完工结
          benefits:[],//工作福利标签
          work_start_time:'',//每日工作开始时间
          work_end_time:'',//每日工作结束时间
          contact:'',//联系人
          phone:'',//联系电话

      },
      rules: {
        project_id: [
          { required: true, message: '请选择项目', trigger: 'change' }
        ],
        company_app_id: [
          { required: true, message: '请选择企业', trigger: 'blur' }
        ],
        title: [
          { required: true, message: '请输入招聘标题', trigger: 'blur' }
        ],
        logo: [
          { required: true, message: '请选择照片头像', trigger: 'blur' }
        ],
        type_id: [
          { required: true, message: '请选择招聘类型', trigger: 'blur' }
        ],
        type_remarks: [
          { required: true, message: '请输入招聘描述', trigger: 'blur' }
        ],
        class_id: [
          { required: true, message: '请选择职位分类', trigger: 'change' }
        ],
        address: [
          { required: true, message: '请填写地址信息', trigger: 'change' }
        ],
        job_start_at: [
          { required: true, message: '请输入活动开始时间', trigger: 'blur' }
        ],
        job_end_at: [
          { required: true, message: '请输入活动结束时间', trigger: 'blur' }
        ],

        registration_end_at: [
          { required: true, message: '请选择报名截止日期', trigger: 'blur' }
        ],

        sex: [
          { required: true, message: '请选择性别', trigger: 'blur' }
        ],
        /*number: [
          { required: true, message: '请输入人数', trigger: 'blur' }
        ],*/
        
        education: [
          { required: true, message: '请选择学历', trigger: 'blur' }
        ],

        major: [
          { required: true, message: '请选择专业', trigger: 'blur' }
        ],
        age_min: [
          { required: true, message: '请填写最小年龄', trigger: 'blur' }
        ],
        age_max: [
          { required: true, message: '请填写最大年龄', trigger: 'blur' }
        ],

        photo: [
          { required: false, message: '请上传工作环境', trigger: 'blur' }
        ],

        description: [
          { required: true, message: '请填写职位描述', trigger: 'blur' }
        ],
        job_require: [
          { required: true, message: '请填写任职要求', trigger: 'blur' }
        ],

        

        all_num: [
              {
                  required: true,
                  message: '请输入招聘人数',
                  trigger: 'blur'
              }
          ],

      
      }

    }
  },

  created(){
    /*console.log("this.info",this.info);
    console.log("this.formData",this.formData);
    var newobj=Object.assign(this.info,this.formData);
    //var newobj={...this.formData,...this.info};
    console.log("newobj",newobj);*/
    //this.formData=this.info;
   
  },
  mounted () {
    console.log("this.$route.query",this.$route.query);

    if(this.$route.query&&this.$route.query.project_id){
      this.formData.project_id=this.$route.query.project_id;
    }
    
    this.initProjectList();

   
  },
  methods:{
    setParams(obj){
      var that=this;
      this.formData=obj;
      this.formData.education=this.formData.education+''
      console.log("that.formData.photo ",that.formData.photo )
      var photoFiles=[];
      for (let item of that.formData.photo) {
        var file={
          name:"1111", url:item,
        }
          photoFiles.push(file);
      }

        that.formData.photoFiles=photoFiles;

        var projectInfo= {
            project_id: obj.project_id,
            company_app_id: obj.company_app_id,
            company_name: obj.company_name,
        }

      this.projectInfo=projectInfo;

    },
    showCategory(){
      this.$refs.refCategory.init();
    },


    
       //项目列表
    initProjectList(){
      var that = this;
      projectList({}).then((response) => {
        that.projectDataList = response.data;
        if(that.formData.project_id){
          for (let item of that.projectDataList) {
            if(item.project_id==that.formData.project_id){
              that.projectInfo=item;
              this.formData.project_id= this.projectInfo.project_id;
              this.formData.company_app_id= this.projectInfo.company_app_id;
              }
          }
        }
      
      });
      
    },

    setClassId(item){
      console.log(item);
      this.formData.class_id=item.value;
      this.formData.class_name=item.label;
      this.$forceUpdate();
      
    },

    setAddress(addressList){
      var that=this;
      
      for (let item of addressList) {

          that.$set(item,'all_num',"");
          that.$set(item,'sex',"");
          that.$set(item,'remark',"");

          for (let item2 of  this.formData.address) {
            if(item.u_address_id ==item2.u_address_id){
              
              that.$set(item,'all_num',item2.all_num);
              that.$set(item,'sex',item2.sex);
              that.$set(item,'remark',item2.remark);
            }
          }

      }
      this.formData.address=addressList;
      this.$forceUpdate();


    },


    selectAddress(){
      if(!this.formData.project_id){

        this.$message.error("请选择项目");
        return;
      }
      this.$refs.selectAddressDialog.init(this.formData.address,this.formData.project_id);
    },

    deleteRow(index, rows) {
        rows.splice(index, 1);
    },
   

    //选择项目
    selectProject(val){
      this.projectInfo=val;
      this.formData.project_id= this.projectInfo.project_id;
      this.formData.company_app_id= this.projectInfo.company_app_id;
      	
    },



    // 上传失败
    uploadFileError(err) {
      this.$message.error("上传失败, 请重试");
    },

    // 删除文件
    handleRemove(files) {
      console.log(files)
      var index =  this.formData.photoFiles.indexOf(files)
      this.formData.photoFiles.splice(index, 1);
      this.formData.photo.splice(index, 1);
      console.log("this.formData.photo",this.formData.photo)
     
    },
  

     // 上传成功的钩子函数
     uploadFileSuccess(response, files) {
      console.log(response);
      if(response.code==1){
        var file={
          name:response.filename, url:response.file,
        }
        this.formData.photoFiles.push(file);
        this.formData.photo.push(response.file);
      }
      
    },




    // 点击上一步
    handleLastStep() {
      this.$emit('handleLastStep')
    },
    
    // 点击下一步
    handleNextStep() {

     // this.$emit('handleNextStep',this.formData);
     
     this.$refs["form"].validate((valid) => {
        if (valid) {
          this.$emit('handleNextStep',this.formData);
        }

      });
    }
  }
}
</script>


<style lang="scss" scoped>
.step_inner {
  h2 {
    margin: 0;
    font-size: 19px;
    line-height: 50px;
  }
  .el-col {
    min-height: 51px;
  }
}
</style>